var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-image"},[_c('nuxt-img',{staticClass:"div-image__image",attrs:{"provider":"twicpics","src":"https://s3.eu-west-3.amazonaws.com/media.agily.fr/teambuilding_1_43a9eb171d.png","alt":"Image de l'équipe lors de notre dernier team building"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }